export default __webpack_public_path__ + "static/media/han-tu-M8b7NRHPwhI-unsplash.4fa88d38.jpg";